<template lang="pug">
    .products-template
        .products-template-title
            p {{ lenguageSelected.content1 }}
        .products-template-content
            .products-template-content-description
                p(v-for="item in lenguageSelected.content2")   {{ item }}
</template>


<script>
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            lenguage: 'ES',
            lenguageEN: {
                content1: 'Site Leasing',
                content2: [
                    'With thousands of owned and managed sites across the Andean region, ATP offers carriers and other telecom companies the variety of locations and solutions needed to reach their customers.',
                    'Our leasing and operations teams have unrivaled experience in telecommunications infrastructure, and are committed to delivering efficient, seamless processes. We offer long-term leases that are designed to benefit all parties, and our pre-negotiated master lease agreements provide carriers with the simplicity and agility they’re looking for when deploying their networks.',
                    'To learn more leasing with ATP, click the “Contact Us” button to your left.'
                ]
            },

            lenguageES: {
                content1: 'Arrendamiento de Sitios',
                content2: [
                    'Con miles de sitios administrados como parte de nuestro portafolio, ATP ofrece a los operadores de telefonía celular y otras compañías de telecomunicaciones una gran variedad de ubicaciones y soluciones para desplegar y densificar sus redes.',
                    'Nuestros equipos de arrendamiento y operaciones tienen una experiencia incomparable en infraestructura de telecomunicaciones y están comprometidos con la entrega de procesos eficientes y continuos. Ofrecemos contratos de arrendamiento a largo plazo que están diseñados para beneficiar a todas las partes, y nuestro acuerdo de arrendamiento maestro pre-negociado brinda a los operadores una agilidad única.',
                    'Para obtener más información sobre el proceso de arrendamiento con ATP, seleccione el boton de la izquierda para ir a la sección de contacto.'
                ]
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/PmWeLease.vue